import React from "react";
import { Column } from "@/components/Datatable/types";
import { Badge } from "@/components/Badge/Badge";
import { Stage } from "../../api/getStages/types";

interface CreateStageColumnsProps {
  onView: (stage: Stage) => void;
}

export function createStageColumns({
  onView,
}: CreateStageColumnsProps): Column<Stage>[] {
  return [
    {
      header: "Name",
      accessorKey: "name",
      enableSorting: true,
      cell: ({ row }) => row.original.name || "—",
    },
    {
      header: "Position",
      accessorKey: "position",
      enableSorting: false,
      cell: ({ row }) => row.original.position ?? "—",
    },
    {
      header: "Description",
      accessorKey: "description",
      enableSorting: true,
      cell: ({ row }) => row.original.description || "—",
    },
    {
      header: "Status",
      accessorKey: "isDeleted",
      cell: ({ row }) =>
        row.original.isDeleted ? (
          <Badge variant="grey">Inactive</Badge>
        ) : (
          <Badge variant="success">Active</Badge>
        ),
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => (
        <button
          className="text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors text-sm"
          onClick={() => onView(row.original)}
          type="button"
        >
          View
        </button>
      ),
    },
  ];
}
